import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, LinkedinIcon, YoutubeIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowUpIcon } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-brand-charcoal border-t border-brand-blue/10 pt-20 pb-10" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-24">
          {/* Column 1: Company Info */}
          <div className="space-y-6" data-id="element-25">
            <Link to="/" className="flex items-center gap-2" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/nxk8PbTo7ETLYk7nrXHatr/Audiotech_logo_(Bags).png" alt="Audiotech Logo" className="h-10 w-auto object-contain" data-id="element-27" />
            </Link>
            <p className="text-brand-muted text-sm leading-relaxed" data-id="element-28">
              Botswana's premier 100% citizen-owned audio-visual and event
              production company, delivering professional technical solutions
              since 2004.
            </p>
            <div className="flex items-center gap-4" data-id="element-29">
              <a href="#" className="text-brand-muted hover:text-brand-blue transition-colors" data-id="element-30">
                <FacebookIcon className="w-5 h-5" data-id="element-31" />
              </a>
              <a href="#" className="text-brand-muted hover:text-brand-blue transition-colors" data-id="element-32">
                <InstagramIcon className="w-5 h-5" data-id="element-33" />
              </a>
              <a href="#" className="text-brand-muted hover:text-brand-blue transition-colors" data-id="element-34">
                <TwitterIcon className="w-5 h-5" data-id="element-35" />
              </a>
              <a href="#" className="text-brand-muted hover:text-brand-blue transition-colors" data-id="element-36">
                <LinkedinIcon className="w-5 h-5" data-id="element-37" />
              </a>
              <a href="#" className="text-brand-muted hover:text-brand-blue transition-colors" data-id="element-38">
                <YoutubeIcon className="w-5 h-5" data-id="element-39" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-40">
            <h3 className="text-white font-semibold mb-6" data-id="element-41">Quick Links</h3>
            <ul className="space-y-4" data-id="element-42">
              <li data-id="element-43">
                <Link to="/" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-44">
                  Home
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/about" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-46">
                  About Us
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-48">
                  Services
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/rentals" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-50">
                  Rentals
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/gallery" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-52">
                  Gallery
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/contact" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-54">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div data-id="element-55">
            <h3 className="text-white font-semibold mb-6" data-id="element-56">Our Services</h3>
            <ul className="space-y-4" data-id="element-57">
              <li data-id="element-58">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-59">
                  Sound Systems
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-61">
                  Stage Hire
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-63">
                  Lighting Solutions
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-65">
                  Visual Equipment
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-67">
                  Video Production
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/services" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-69">
                  Events Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-id="element-70">
            <h3 className="text-white font-semibold mb-6" data-id="element-71">Contact Us</h3>
            <ul className="space-y-4" data-id="element-72">
              <li className="flex items-start gap-3" data-id="element-73">
                <MapPinIcon className="w-5 h-5 text-brand-blue shrink-0 mt-0.5" data-id="element-74" />
                <span className="text-brand-muted text-sm" data-id="element-75">
                  Gaborone, Botswana
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-76">
                <PhoneIcon className="w-5 h-5 text-brand-blue shrink-0" data-id="element-77" />
                <a href="tel:+2673928692" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-78">
                  (+267) 3928692
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-79">
                <PhoneIcon className="w-5 h-5 text-brand-muted shrink-0" data-id="element-80" />
                <span className="text-brand-muted text-sm" data-id="element-81">
                  Fax: (+267) 3928169
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-82">
                <MailIcon className="w-5 h-5 text-brand-blue shrink-0" data-id="element-83" />
                <a href="mailto:info@audiotech.co.bw" className="text-brand-muted hover:text-brand-blue transition-colors text-sm" data-id="element-84">
                  info@audiotech.co.bw
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-85">
          <p className="text-brand-muted text-sm" data-id="element-86">
            &copy; {new Date().getFullYear()} AUDIOTECH. All rights reserved.
          </p>
          <button onClick={scrollToTop} className="flex items-center gap-2 text-sm text-brand-muted hover:text-white transition-colors group" data-id="element-87">
            Back to Top
            <div className="w-8 h-8 rounded-full bg-brand-slate flex items-center justify-center group-hover:bg-brand-blue transition-colors" data-id="element-88">
              <ArrowUpIcon className="w-4 h-4" data-id="element-89" />
            </div>
          </button>
        </div>
      </div>
    </footer>;
}